import {Button, Form, Input, Row} from "antd";
import {authenticationService} from "api";
import {InputFields, Notification} from "components/common";
import {FIELD_TYPE} from "types/enums";

const {INPUT} = FIELD_TYPE;

import React, {forwardRef, useImperativeHandle} from "react";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";
const ModalPassword = forwardRef((props: any, ref) => {
  const {id} = props;
  const [form] = Form.useForm<any>();
  useImperativeHandle(ref, () => ({
    resetFields: () => {
      form.resetFields();
    },
  }));
  const onSubmit = async () => {
    try {
      const values = await form.validateFields();
      resetPassword(values?.password);
    } catch (error) {}
  };
  const resetPassword = async password => {
    try {
      const params = {value: password, temporary: false, type: "password"};
      await authenticationService.resetPass(id, params);
      Notification("success", "Đã cập nhật mật khẩu");
    } catch (error) {
      console.log(error);
      Notification("error", "Đã có lỗi");
    }
  };
  const wrapperCol = {xs: 16, md: 16, xl: 16, lg: 16};
  const labelCol = {xs: 6, md: 6, xl: 6, lg: 6};

  return (
    <div>
      <Form form={form} labelAlign="left">
        <Form.Item
          name={"password"}
          rules={[{required: true, message: "Chưa nhập mật khẩu"}]}
          label="Mật khẩu"
          wrapperCol={wrapperCol}
          labelCol={labelCol}
        >
          <Input.Password
            placeholder="Nhập mật khẩu"
            iconRender={visible =>
              visible ? (
                <EyeTwoTone rev={undefined} />
              ) : (
                <EyeInvisibleOutlined rev={0} />
              )
            }
          />
        </Form.Item>
      </Form>
      <Row justify="end" style={{marginTop: 4}}>
        <Button type="primary" onClick={onSubmit}>
          Lưu
        </Button>
      </Row>
    </div>
  );
});
export default ModalPassword;
